<template>
    <div class="login-container">
        <!-- 左侧占位 -->
        <div class="left"></div>
        <!-- 右侧占位 -->
        <div class="right">
            <div class="big-title"></div>
            <div class="login-box">
                <div class="login-box-title">登录</div>
                <div class="line"><div class="line-left">账号： </div> <div class="line-right">  <Input v-model="username" placeholder="请输入账号..." style="width: 300px" /> </div>  </div>
                <div class="line">
                    <div class="line-left">密码： </div> 
                    <div class="line-right">  
                        <Input v-model="password" placeholder="请输入账密码..." style="width: 300px" :type="showPassword?'text':'password'" >
                            <template  #suffix>
                                <!-- <Icon type="md-eye" /> -->
                                <Icon :type="showPassword?'md-eye':'ios-eye-off-outline'" @click="showPassword=!showPassword"/>
                            </template>
                        </Input> 
                    </div>  
                </div>
                <div class="line" style="height:50px;align-items: center;justify-content: center;gap:50px;">
                    <Button type="default" style="width: 200px" @click="clear">清空</Button>
                    <Button type="primary" style="width: 200px" @click="login" >登录</Button>
                </div>
                <!-- <div class="line" style="height:50px;align-items: center;justify-content: center;gap:50px;"> 
                    <Button type="primary" ghost style="width: 450px" @click="go_old_version">晓家碧寓系统入口</Button>
                </div> -->
            </div> 
        </div>
       
    </div>
  </template>
  
  <script>
  import {loginMethod} from "@/api/login/loginMethod.js";
  export default {
    data() {
      return {
        username: 'admin',
        password: '',
        rememberMe: false,
        showPassword:false,//是否显示密码
      };
    },
    created(){
      console.log("1111====")
      loginMethod.test().then((restest) =>{
                    console.log("restest====",restest)
            })
    },
    methods: {
      handleLogin() {
        if (this.username==null||this.username==""||this.username==undefined) {
            this.$Message.warning('请输入用户名');
            return false;
        }
        if (this.password==null||this.password==""||this.password==undefined) {
            this.$Message.warning('请输入密码');
            return false;
        }
        // 登录逻辑
        console.log('登录', this.username, this.password, this.rememberMe);
      },
      login(){
        if(!this.handleLogin){
            return false;
        }else{
            console.log("else")
            let param={
                username:this.username,
                password:this.password
            }
            loginMethod.loginV2(param).then((res) =>{
                    console.log("res====",res)
                     console.log("userInfo====",res.data.userInfo)
                    if(res.data.loginResult){
                      // this.$Message.success("登陆失败，请检查您输入的账号和密码!")
                    this.$store.commit('clearUserInfo'); // 调用 Vuex mutation
                    this.$store.commit('clearToken'); // 调用 Vuex mutation
                      localStorage.removeItem('userInfo'); // 先清掉旧的
                      this.$store.commit('setMenuData', res.data.menuList);
                      this.$store.commit('setUserInfo', res.data.userInfo);
                      localStorage.setItem('token', res.data.token);
                      this.$store.commit('setLoginStatus', true);
                      this.$nextTick(()=>{
                        this.$router.push({ name: 'Home' });
                      })
                    }else{
                      this.$Message.error("登陆失败，请检查您输入的账号和密码!")
                    }
                    
            })
        }
      },
      forgotPassword() {
        // 忘记密码逻辑
        console.log('忘记密码');
      },
        // 清空
        clear(){
            this.username="";
            this.password=""
        },
        // 旧版本登录
        go_old_version(){
          window.open("https://mp.xiaojiabiyu.net.cn/", '_blank');
        }

    }
  };
  </script>
  
  <style lang="scss" >
@import 'login.scss'; 

  </style>
  